import {CompetitorDto, CompetitorForm} from "@/src/entities/competitor/model/types";
import {parseDate} from "@internationalized/date";

export function competitorDtoToForm(competitor: CompetitorDto): CompetitorForm {
    return {
        id: competitor.id,
        clientId: String(competitor.id),
        firstName: competitor.firstname,
        surname: competitor.surname,
        patronymic: competitor.patronymic,
        birthDate: parseDate(competitor.date_of_birth), // Assuming birthDate is in YYYY
        gender: competitor.gender,
        rank: competitor.rank,
    };
}

export function competitorListDtoToForm(competitors: CompetitorDto[]): CompetitorForm[] {
    return competitors.map(competitorDtoToForm);
}

export function competitorFormToDto(form: CompetitorForm): Omit<CompetitorDto, 'id'> { // when pushing we dont need id, id will be in request path
    return {
        firstname: form.firstName,
        surname: form.surname,
        patronymic: form.patronymic,
        date_of_birth: form.birthDate!.toString(), // in form they couldnt be undefined
        gender: form.gender!,
        rank: form.rank!,
    }
}